import React from 'react';
import AsyncSelect from 'react-select/async';
import {fetchEstates} from '../data/fetchData';

function EstateAutocomplete({
                                value,             // ← pull in the current selection option
                                onEstateChange,
                                placeholder,
                                inputId
                            }) {
    const loadOptions = async (inputValue) => {
        if (inputValue.length < 3) return [];
        const estates = await fetchEstates(inputValue);
        return estates.map(est => ({
            label: est.address,
            value: est.id,
            estate: est,
        }));
    };

    return (
        <AsyncSelect
            cacheOptions
            defaultOptions={false}
            loadOptions={loadOptions}
            // ← now hand back the full option { label, value, estate }
            onChange={opt => onEstateChange(opt)}
            value={value}
            placeholder={placeholder}
            inputId={inputId}
            isClearable
            noOptionsMessage={({inputValue}) =>
                inputValue.length < 3
                    ? 'Tippige vähemalt 3 tähemärki…'
                    : 'Ei leia vastavaid kinnistuid'
            }
        />
    );
}

export default EstateAutocomplete;
